import { ArrowsRightLeftIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from 'components/layout/popover';
import Tooltip from 'components/layout/tooltip';
import { useState } from 'react';
import { ComparisonSystemPick } from './comparison-system-pick';
import ComparisonSystemPicker, {
  ComparisonSystemPickerProps
} from './comparison-system-picker';

export default function SwapSystemPopover({
  onPick,
  ...pickerProps
}: ComparisonSystemPickerProps) {
  const [open, setOpen] = useState(false);

  const handlePick = (pick: ComparisonSystemPick) => {
    setOpen(false);
    onPick(pick);
  };

  return (
    <Popover open={open} onOpenChange={setOpen} placement='bottom-end'>
      <PopoverTrigger
        onClick={() => setOpen((v) => !v)}
        aria-label='Swap this system for another'
        className={clsx(
          'relative inline-flex shrink-0 cursor-pointer items-center justify-center gap-1 rounded-md px-2 py-1 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500',
          open ? 'bg-blue-200' : 'bg-white hover:bg-blue-100'
        )}
      >
        <ArrowsRightLeftIcon className='h-4 w-4' />
        <Tooltip text='Swap this system for another' />
      </PopoverTrigger>
      <PopoverContent className='z-50 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xl focus:outline-none'>
        <ComparisonSystemPicker {...pickerProps} onPick={handlePick} />
      </PopoverContent>
    </Popover>
  );
}
